<script setup lang="ts">
  import { cn } from "@/lib/utils"
  import { DrawerTitle, type DrawerTitleProps } from "reka-ui"
  import { computed, type HTMLAttributes } from "vue"

  const props = defineProps<
    DrawerTitleProps & { class?: HTMLAttributes["class"] }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })
</script>

<template>
  <DrawerTitle
    :class="cn('h4 text-foreground', props.class)"
    v-bind="delegatedProps"
  >
    <slot />
  </DrawerTitle>
</template>
